export function isTargetGroupEmpty({ users, userGroups, masterGroups, customGroups, jobTitles }) {
  return (
    users.length === 0 &&
    userGroups.length === 0 &&
    masterGroups.length === 0 &&
    customGroups.length === 0 &&
    jobTitles.length === 0
  );
}
